"use client";
import { ChangeEvent, SetStateAction, useEffect, useState } from "react";
import { useQuery } from "react-query";

import _ from "lodash";
import axios from "axios";
import keyword_extractor from "keyword-extractor";

import {
  Box,
  CircularProgress,
  Radio,
  RadioGroup,
  FormControlLabel,
  InputLabel,
  Select,
  FormControl,
  MenuItem,
  SelectChangeEvent,
  TextField,
  Button,
  Modal,
  Checkbox,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";

import { categoryTags, cleanAnswer, combinedTags, getMappedTags, specificTags } from "../../data/tags";
import "./solutions.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { brandingColors, getAgeGroupLabel, getSeason } from "../../components/utils";
import Header from "../../components/header/header";
import { getSkinTypeValue } from "../../data/skin-types";
import { handleSubmit } from "../../services/openai";
import ReactLoading from "react-loading";
import SkinTypeItemComponent from "../../components/chatbox/skintype-item";
import StepComponent from "../../components/solution-page/step/step";
import { subscribe } from "../../services/subscription";
import FooterComponent from "../../components/footer";
import { createQuiz, useQuizQuery } from "../../services/quiz-service";
import SaveSolutionComponent from "../../components/save-solution/save-solution";


const getskincareProduct = () => {
  const options = {
    method: "GET",
    url: `https://d222hu8pcowl39.cloudfront.net/default/querying?TableName=product`,
  };

  return axios.request(options);
};

const getSignals = async () => {
  const skincareProduct = await getskincareProduct();
  const skincareProducts = _.get(skincareProduct, "data.Items") || [];

  return { skincareProducts };
};

export default function Solutions(): JSX.Element {
  const urlParams = new URLSearchParams(window.location.search);
  let question = urlParams.get("q") || "";
  let filters = JSON.parse(urlParams.get("filters") || "{}");
  

  const scrollTo = (id: string) => {
    var element = document.getElementById(id);
      var headerOffset = 70;
      var elementPosition = element!.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
  }

  /*** get parameters START */
  const quizId = urlParams.get("quizId") || "";
  /*** get parameters END */

  /*** get the season by current location START ***/
  const [season, setSeason] = useState("");
  const getCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (position: GeolocationPosition) => {
        const currentSeason = getSeason(position.coords.latitude);
        setSeason(currentSeason);
      },
      (error) => {

      },
      { enableHighAccuracy: true }
    );
  }

  
  /*** get the season by current location END ***/

  /**** chatbox start *******/
  const [skinType, setSkinType] = useState("");
  const [sensitive, setSensitive] = useState<boolean | null>(null);
  const [ageGroup, setAgeGroup] = useState("");
  const [disclamerChecked, setDisclamerChecked] = useState(false);
  const [cleanedAiAnswer, setCleanedAiAnswer] = useState("");

  const skinTypeDefinitions = {
    'Oily': [
      'Excessive production of sebum (natural oil)', 
      'Shiny or greasy appearance, especially in the T-zone (forehead, nose, chin)', 
      'Enlarged pores', 
      'Prone to acne, blackheads, and other blemishes'],
    'Combination-Oily': [
      'Oily T-zone (forehead, nose, chin)',
      'Normal or slightly oily areas on the cheeks',
      'Requires balancing care for both oily and normal areas'
    ],
    'Combination-Dry': [
      'Oily T-zone (forehead, nose, chin)',
      'Dry or flaky areas on the cheeks and jawline',
      'Needs tailored care for both dry and oily regions'
    ],
    'Dry': [
      'Insufficient moisture and natural oils',
      'Rough, flaky, or scaly texture',
      'Tight or itchy feeling',
      'Small pores, less prone to acne',
      'Susceptible to irritation, redness, and sensitivity'
    ]
  }

  
  const quizRes = useQuizQuery(quizId);
  useEffect(() => {
    if (quizRes.status === 'success' && quizRes.data.data) {
      const quiz = quizRes.data.data;
      setSkinType(quiz.skinType);
      setSensitive(quiz.sensitive);
      setAgeGroup(quiz.ageGroup);
      setCleanedAiAnswer(quiz.answer);
      setDisclamerChecked(true);
      setSeason(quiz.season);
    }
    if (season === '') {
      if (navigator.geolocation) {
        getCurrentLocation();
      }
      else {
        alert("Geolocation is not supported by this browser.");
      }
    }
  }, [quizRes]);
  

  const handleSkinTypeChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSkinType((event.target as HTMLInputElement).value);
    setTimeout(() => {
      var element = document.getElementById('chatbox-skintype-answer');
      var headerOffset = 70;
      var elementPosition = element!.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    },10)
  };

  const handleSensitiveChange = (value: boolean) => {
    setSensitive(value);
    setTimeout(() => scrollTo('chatbox-sensitive-answer'), 10);
  }

  const handleAgeGroupChange = (event: ChangeEvent<HTMLInputElement>) => {
    const ageGroup = (event.target as HTMLInputElement).value;
    setAgeGroup((event.target as HTMLInputElement).value);

    setTimeout(() => scrollTo('middle-right'), 1);
  }

  const handleDisclamerCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisclamerChecked(event.target.checked);
    if (event.target.checked) {
      handleSubmit(question, skinType, sensitive, season).then((res) => {
      if (res) {
        const resContent = res.data;
        const body = resContent.body;
        const jsonBody = JSON.parse(body);
        const cleanedAnswer = cleanAnswer(jsonBody.response);
        updateCleanedAiAnswer(cleanedAnswer);
        saveQuiz(ageGroup, cleanedAnswer);
      }
    } );
    }
  };

  const handleTryAgain = () => {
    const currentDate = new Date();
    const quizId = currentDate.valueOf().toString();
    window.location.href = "/solutions?q=" + encodeURI(question) + "&quizId=" + quizId;
  }

  const updateCleanedAiAnswer = (cleanedAnswer: string) => {
    setCleanedAiAnswer(cleanedAnswer);
  }

  const saveQuiz = (ageGroup: string, answer: string) => {
    const quiz = {
      quizId: quizId,
      query: question,
      skinType: skinType,
      sensitive: sensitive,
      ageGroup: ageGroup,
      season: season,
      answer: answer,
      createtime: new Date().toISOString(),
    }
    createQuiz(quiz);
  }
  /**** chatbox end *******/

  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  const { data, status } = useQuery("posts", getSignals, {
    refetchOnWindowFocus: false
  });

  /***** filter products START ******/
  let products : any[] = [];
  if (cleanedAiAnswer !== "") {
    products = _.get(data, "skincareProducts");
  }
  
  let allProducts = _.get(data, "skincareProducts");

  const [message, setMessage] = useState("");

  products = _.filter(products, (x) => {
    return x.display;
  });

  /*if (filters.gender > 0) {
    products = _.filter(products, (x) => {
      return x.gender === _.toString(filters.gender) || x.gender === "1";
    });
  }*/
  
  // filter product by sensitive skin
  if (sensitive !== null && filters.sensitive) {
    products = _.filter(products, (x) => {
      return x.sensitiveSkin === filters.sensitive;
    });
  }

  // filter product by skin type
  /*if (!_.isEmpty(filters.skinType)) {
    products = _.filter(products, (x) => {
      let match = false;
      _.forEach(filters.skinType, (st) => {
        if (_.includes(x.skinType, st)) {
          match = true;
        }
      });
      return match;
    });
  }*/

  if (skinType !== "") {
    products = _.filter(products, (x) => {
      return _.includes(x.skinType, skinType);
    });
  }

  /*if (!_.isEmpty(filters.ageGroup)) {
    products = _.filter(products, (x) => {
      let match = false;
      _.forEach(filters.ageGroup, (ag) => {
        if (_.includes(x.age, ag)) {
          match = true;
        }
      });
      return match;
    });
  }*/

  if (ageGroup !== "") {
    products = _.filter(products, (x) => {
      return _.includes(x.age, ageGroup);
    });
  }

  // filter product by season
  if (season !== "") {
    products = _.filter(products, (x) => {
      if (season === 'Spring' || season === 'Summer') {
        return x.timeOfYear === 'All' || x.timeOfYear === 'Summer';
      } else {
        return x.timeOfYear === 'All' || x.timeOfYear === 'Winter';
      }
    })
  }

  // filter product by ai tags or keywords
  const containKeywords = (product: any) => {
    let contain = false;
    const search = question ? question : "";
    const extraction_result = keyword_extractor.extract(search, {
      language: "english",
      remove_digits: true,
      return_changed_case: true,
      remove_duplicates: false,
    });
    
    for (const keyword of extraction_result) {
      if (_.includes(_.toLower(product.description), _.toLower(keyword))) {
        contain = true;
      }
      if (
        _.includes(_.toLower(product.backendDescription), _.toLower(keyword))
      ) {
        contain = true;
      }
      if (
        _.includes(
          _.toLower(product.benefitsFromKeyIngredients),
          _.toLower(keyword)
        )
      ) {
        contain = true;
      }
      if (_.includes(_.toLower(product.effectKeywords), _.toLower(keyword))) {
        contain = true;
      }
      if (_.includes(_.toLower(product.ingredientList), _.toLower(keyword))) {
        contain = true;
      }
      if (_.includes(_.toLower(product.keyIngredients), _.toLower(keyword))) {
        contain = true;
      }
      if (_.includes(_.toLower(product.productFeature), _.toLower(keyword))) {
        contain = true;
      }
      if (_.includes(_.toLower(product.pros), _.toLower(keyword))) {
        contain = true;
      }
      if (
        _.includes(_.toLower(product.frontendDescription), _.toLower(keyword))
      ) {
        contain = true;
      }
    }
    return contain;
  };

  // 1 - get ai answer
  let aiAnswer = cleanedAiAnswer;

  // 2 - filter out category tags maximum 4
  let questionCategoryTags = _.filter(categoryTags, (t) => {
    return question.toLowerCase().includes(t.toString().toLowerCase());
  })

  let aiCombinedTags = _.filter(combinedTags, (t) => {
    return aiAnswer ? aiAnswer.toLowerCase().includes(t.toString().toLowerCase()) : false
  })


  let aiCategoryTags = _.filter(categoryTags, (t) => {
    if (question.toLowerCase().includes(t.toString().toLowerCase())) {
      return false;
    } else if (question.includes('gently cleanse') && t === 'gentle cleansing') {
      return true;
    }
    else {
      return aiAnswer ? aiAnswer.toLowerCase().includes(t.toString().toLowerCase()) : false
    }
  })
  
  let resultedCategoryTags: string[] = [];
  if (questionCategoryTags.length > 0) {
    questionCategoryTags.forEach(t => {
      if (t === 'cleansing') {
        if (!resultedCategoryTags.includes('gentle cleansing') && resultedCategoryTags.includes('gentle cleanser')) {
          resultedCategoryTags.push(t);
        }
      } else {
        resultedCategoryTags.push(t);
      }
    })
  }

  if (aiCombinedTags.length > 0) {
    aiCombinedTags.forEach(t => resultedCategoryTags.push(t));
  }

  if (aiCategoryTags.length > 0) {
    //resultedCategoryTags.push(...aiCategoryTags);
    aiCategoryTags.forEach(t => {
      if (t === 'cleansing') {
        if (!resultedCategoryTags.includes('gentle cleansing') && resultedCategoryTags.includes('gentle cleanser')) {
          resultedCategoryTags.push(t);
        }
      } else {
        resultedCategoryTags.push(t);
      }
    })
  }

  
  //resultedCategoryTags = resultedCategoryTags.length > 5 ? resultedCategoryTags.slice(0, 5) : resultedCategoryTags;
  const resultedCategoryMappedTags = _.map(resultedCategoryTags, (t) => {
    return getMappedTags(t);
  })

  products = _.filter(products, (x) => {
    let contain = false;
    x['score'] = 0;
    if (resultedCategoryMappedTags.length > 0) {
      for (const tag of resultedCategoryMappedTags) {
        if (_.includes(_.toLower(x.tags), _.toLower(tag))) {
          contain = true;
          x['score']++; 
        }
      }
    }
    return contain;
  });

  // 3 - filter out specific tags
  let questionSpecificTags = _.filter(specificTags, (t) => {
    return question.toLowerCase().includes(t.toString().toLowerCase());
  })
  let aiSpecificTags = _.filter(specificTags, (t) => {
    if (question.toLowerCase().includes(t.toString().toLowerCase())) {
      return false;
    } else {
      return aiAnswer ? aiAnswer.toLowerCase().includes(t.toString().toLowerCase()) : false
    }
  })
  let resultedSpecificTags: string[] = [];
  if (questionSpecificTags.length > 0) {
    resultedSpecificTags.push(...questionSpecificTags);
  }
  if (aiSpecificTags.length > 0) {
    resultedSpecificTags.push(...aiSpecificTags);
  }

  
  //const restTagQuantity = 8 - resultedCategoryTags.length;
  //resultedSpecificTags = resultedSpecificTags.length >  restTagQuantity ? resultedSpecificTags.slice(0, restTagQuantity) : resultedSpecificTags;
  const resultedSpecificMappedTags = _.map(resultedSpecificTags, (t) => {
    return getMappedTags(t);
  })
  if (resultedSpecificMappedTags.length > 0) {
    products = _.filter(products, (x) => {
      let contain = false;
      x['score'] = 0;
      for (const tag of resultedSpecificMappedTags) {
        if (_.includes(_.toLower(x.tags), _.toLower(tag))) {
          contain = true;
          x['score']++; 
        }
      }
      return contain;
    });
  }
  
  // 4 - combine tags to show
  let aiContainedTags: string[] = [];
  if (resultedCategoryMappedTags.length > 0) {
    aiContainedTags.push(...resultedCategoryMappedTags);
  }
  if (resultedSpecificMappedTags.length > 0) {
    aiContainedTags.push(...resultedSpecificMappedTags);
  }
  const aiTagsToShow = aiContainedTags.length > 0 ? _.join(aiContainedTags, ', ') : '';

  products = _.reverse(_.sortBy(products, "score"));

  

  /* set list for each step and more products logic START */
  const getFullStepList = (step: string) => {
    let result = _.filter(products, (x) => {
      return x.step === `Step ${step}`;
    });
    if (result.length > 0) {
      result[0]['pick'] = true;
    }
    return result;
  };

  const [list1tries, setList1Tries] = useState(0);
  const [list2tries, setList2Tries] = useState(0);
  const [list3tries, setList3Tries] = useState(0);
  const [list4tries, setList4Tries] = useState(0);

  const fullList1 = getFullStepList('1');
  const fullList2 = getFullStepList('2');
  const fullList3 = getFullStepList('3');
  const fullList4 = getFullStepList('4');

  const getStepList = (step: string) => {
    let list = [];
    let start = 0;
    if (step === '1') {
      list = fullList1;
      start = list1tries * 3;
    }
    if (step === '2') {
      list = fullList2;
      start = list2tries * 3;
    }
    if (step === '3') {
      list = fullList3;
      start = list3tries * 3;
    }
    if (step === '4') {
      list = fullList4;
      start = list4tries * 3;
    }
    
    return _.slice(list, start, getEndPosition(list, start));
  };

  const getEndPosition = (list: any[], start: number) => {
    let end = start + 3;
    end = end > list.length ? list.length : end;
    return end;
  }

    const [list1, setList1] = useState(getStepList("1"));
    const [list2, setList2] = useState(getStepList("2"));
    const [list3, setList3] = useState(getStepList("3"));
    const [list4, setList4] = useState(getStepList("4"));

    /*useEffect(() => {
      if (products.length > 0) {
        setList1(getStepList("1"));
        setList2(getStepList("2"));
        setList3(getStepList("3"));
        setList4(getStepList("4"));
      }
    }, [products]);*/

    useEffect(() => {
      if (products.length > 0) {
        setList1(fullList1);
        setList2(fullList2);
        setList3(fullList3);
        setList4(fullList4);
      }
    }, [products]);

  const updateList = (step: string) => {
    if (step === "1") {
      if ((list1tries+1)*3 >= fullList1.length) {
        setList1Tries(0);
      } else {
        setList1Tries(list1tries+1);
      }
      setList1(getStepList("1"));
    }
    if (step === "2") {
      if ((list2tries+1)*3 >= fullList2.length) {
        setList2Tries(0);
      } else {
        setList2Tries(list2tries+1);
      }
      setList2(getStepList("2"));
    }
    if (step === "3") {
      if ((list3tries+1)*3 >= fullList3.length) {
        setList3Tries(0);
      } else {
        setList3Tries(list3tries+1);
      }
      setList3(getStepList("3"));
    }
    if (step === "4") {
      if ((list4tries+1)*3 >= fullList4.length) {
        setList4Tries(0);
      } else {
        setList4Tries(list4tries+1);
      }
      setList4(getStepList("4"));
    }
  };
  /* set list for each step and more products logic END */

  const [open, setOpenState] = useState(false);

  /* facets filter START */
  const [stepFacetValue, setStepFacetValue] = useState("0");
  const handleStepChange = (event: SelectChangeEvent) => {
    setStepFacetValue(event.target.value as string);
  };
  const handleGenderChange = (event: SelectChangeEvent) => {
    //setGenderFacetValue(event.target.value as string);
    const gender = event.target.value as string;
    setList1(_.filter(list1, (x) => {
      return x.gender === _.toString(filters.gender) || x.gender === "1";
    }))
    setList2(_.filter(list2, (x) => {
      return x.gender === _.toString(filters.gender) || x.gender === "1";
    }))
    setList3(_.filter(list3, (x) => {
      return x.gender === _.toString(filters.gender) || x.gender === "1";
    }))
    setList4(_.filter(list4, (x) => {
      return x.gender === _.toString(filters.gender) || x.gender === "1";
    }))
  };
  /* facets filter END */

  /* save solution START */
  const [openSaveSolutionDialog, setOpenSaveSolutionDialog] = useState(false);
  const handleOpen = () => setOpenSaveSolutionDialog(true);
  const handleClose = () => setOpenSaveSolutionDialog(false);
  /* save solution END */

  /* subscription */
  const [email, setEmail] = useState("");
  const handleEmailChange = (event: {
    target: { value: SetStateAction<string> };
  }) => {
    setEmail(event.target.value);
  };
  const [showSuccess, setShowSuccess] = useState(false);
  const handleButtonClick = () => {
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
    }, 1500);
}
  /***********/

  if (status === "loading") {
  //if (isLoading) {
    return (
      <div className="loading-container">
        <CircularProgress />
      </div>
    );
  } else {

  return (
    <div className="solution-page">
      <Header showLogo={true} />

      <div className="main">
        <div className="container">
          <div className="wrapper">

            {/* top */}
            <div className="top-content">
              <div className="search-button">
                <a className="btn-new-search" href="/" >
                  New Search
                  <SearchIcon className="search-icon" />
                </a>
              </div>
              
              <div className="search-topic">
                <span>" {question} "</span>
                <img src="/assets/user.svg"/>
              </div>
            </div>

            {/* middle */}
            <div className="middle-content">
              {/* chatbox */}
              <div className="chatbox">
                <div className="user-answer">
                  <div className="user-answer-wrapper">{question}</div>
                </div>
                <div>
                  <div className="ask">
                    In order to give you a better skincare advice, I need to ask you some questions first
                  </div>
                </div>
                <div>
                  <div className="ask">
                    <p>Choose a description that best describes your skin type</p>
                    <Box className="filter-options"
                      sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        justifyContent: "space-around",
                      }}
                    >
                      <div className="skintype-icons">
                        <div><img src="/assets/oily-mark.png"/>oily</div>
                        <div><img src="/assets/dry-mark.png"/>dry</div>
                        <div><img src="/assets/normal-mark.png"/>normal</div>
                      </div>
                      <RadioGroup
                        value={skinType}
                        onChange={handleSkinTypeChange}>
                          <SkinTypeItemComponent skinType={skinType} imgSrc={"/assets/oily.png"} value={"1"} label={"Oily"} definitions={skinTypeDefinitions['Oily']} />
                          <SkinTypeItemComponent skinType={skinType} imgSrc={"/assets/combination-oily.png"} value={"2"} label={"Combination-Oily"} definitions={skinTypeDefinitions["Combination-Oily"]} />
                          <SkinTypeItemComponent skinType={skinType} imgSrc={"/assets/combination-dry.png"} value={"3"} label={"Combination-Dry"} definitions={skinTypeDefinitions["Combination-Dry"]} />
                          <SkinTypeItemComponent skinType={skinType} imgSrc={"/assets/dry.png"} value={"4"} label={"Dry"} definitions={skinTypeDefinitions["Dry"]} />
                      </RadioGroup>
                    </Box>
                  </div>
                </div>
                {skinType ? (<div id="chatbox-skintype-answer" className="user-answer">
                  <div className="user-answer-wrapper">{getSkinTypeValue(skinType)}</div>
                </div>) : ''}
                {skinType ? (
                  <div>
                    <div className="ask">
                      <p>Do you have sensitive skin?</p>
                      <p>Sensitive skin means that your face often reacts to triggers like weather, allergies, or certain products. Yours might turn red, dry out, sting, feel itchy or tight, or get bumps, scales, or hives.</p>
                      <div className="actions">
                        <button className="btn" disabled={sensitive !== null ? true : false} onClick={() => handleSensitiveChange(true)}>Yes</button>
                        <button className="btn" disabled={sensitive !== null ? true : false} onClick={() => handleSensitiveChange(false)}>No</button>
                      </div>
                    </div>
                  </div>
                ) : ''}

                {sensitive !== null ? (
                  <div id="chatbox-sensitive-answer" className="user-answer">
                    <div className="user-answer-wrapper">{sensitive === true ? 'Yes' : 'No'}</div>
                  </div>
                ) : ''}

                {sensitive !== null ? (
                  <div>
                    <div className="ask">
                      <p>What is your age range</p>
                      <RadioGroup
                        value={ageGroup}
                        onChange={handleAgeGroupChange}>
                          <FormControlLabel value="A" control={<Radio disabled={ageGroup ? true : false}  />} label="15 - 20" />
                          <FormControlLabel value="B" control={<Radio disabled={ageGroup ? true : false}  />} label="21 - 25" />
                          <FormControlLabel value="C" control={<Radio disabled={ageGroup ? true : false}  />} label="26 - 35" />
                          <FormControlLabel value="D" control={<Radio disabled={ageGroup ? true : false}  />} label="36 - 50" />
                          <FormControlLabel value="E" control={<Radio disabled={ageGroup ? true : false}  />} label="50+" />
                      </RadioGroup>
                    </div>
                  </div>
                ) : ''}

                {ageGroup !== "" ? (
                  <div className="user-answer">
                    <div className="user-answer-wrapper">{getAgeGroupLabel(ageGroup)}</div>
                  </div>
                ) : ''}
              </div>

              {/* product list */}
              <div id="middle-right" className="right">
                {/* disclamer */}
                {ageGroup !== "" && !disclamerChecked ? (
                  <div className="flow-end">
                    <div className="disclamer">
                      <p className="content">
                      The skincare product suggestions provided by our AI are based on general information and user inputs. These suggestions are not intended to diagnose, treat, cure, or prevent any skin conditions, and they do not replace the advice of a licensed dermatologist or healthcare provider. Always perform a patch test before trying new products, and consult a healthcare professional for personalized skincare advice, particularly if you have a known skin condition or allergy.
                      </p>
                      <FormControlLabel className="checkbox-field" control={<Checkbox checked={disclamerChecked} onChange={handleDisclamerCheckboxChange} />} label="I understand." />
                    </div>
                  </div>
                ) : ""}
                {/* our suggestions */}
                {cleanedAiAnswer !== "" ? (
                  <div className="flow-end">
                    <div className="suggestions">
                      <p className="title">Our suggestions:</p>
                      <p className="content">{cleanedAiAnswer}</p>
                    </div>
                  </div>
                ) : (
                  disclamerChecked ? <div className="flow-end"><ReactLoading type={'balls'} color="#ecebfc" /></div> : ''
                )}
              
                {products.length === 0 ? '' : (
                <div className="product-list">
                <div className="facets">
                  <FormControl variant="filled">
                    <InputLabel id="step-select-label">Step</InputLabel>
                    <Select className="select"
                      labelId="step-select-label"
                      label="Step"
                      defaultValue="0"
                      onChange={handleStepChange}
                    >
                      <MenuItem value="0">All steps</MenuItem>
                      <MenuItem value="1">Step 1</MenuItem>
                      <MenuItem value="2">Step 2</MenuItem>
                      <MenuItem value="3">Step 3</MenuItem>
                      <MenuItem value="4">Step 4</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl variant="filled" className="gender-form-control">
                    <InputLabel id="gender-select-label">Gender</InputLabel>
                    <Select className="select"
                      labelId="gender-select-label"
                      label="Gender"
                      defaultValue="1"
                      onChange={handleGenderChange}
                    >
                      <MenuItem value="1">All</MenuItem>
                      <MenuItem value="2">Man</MenuItem>
                      <MenuItem value="3">Woman</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                {/*<Box className="description"
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    padding: "12px 0px 0px 0px",
                  }}
                >
                  <Typography className="category-title"
                    variant={"subtitle2"}
                    sx={{
                      color: brandingColors["red"],
                    }}
                  >
                    Products below are coherent with the above suggestion. Click on the products you like for more info.
                  </Typography> 
                </Box>*/}

                <div className="product-list-wrapper">

                  {stepFacetValue === "0" ? (
                    <StepComponent productList={list1} stepTitle={"Step 1 - cleansing and make-up remover"} amount={1} 
                      question={question} 
                      quizId={quizId} />
                  ) : (
                    stepFacetValue === "1" ? (
                      <StepComponent productList={list1} stepTitle={"Step 1 - cleansing and make-up remover"} amount={4} 
                        question={question} 
                        quizId={quizId} />
                    ) : ''
                  )}

                  {stepFacetValue === "0" ? (
                    <StepComponent productList={list2} stepTitle={"Step 2 - toner, serum, exfoliation and pad"} amount={1} 
                      question={question} 
                      quizId={quizId} />
                  ) : (
                    stepFacetValue === "2" ? (
                      <StepComponent productList={list2} stepTitle={"Step 2 - toner, serum, exfoliation and pad"} amount={4} 
                        question={question} 
                        quizId={quizId} />
                    ) : ''
                  )}

                  {stepFacetValue === "0" ? (
                    <StepComponent productList={list3} stepTitle={"Step 3 - moisturizer and face oil"} amount={1} 
                      question={question} 
                      quizId={quizId} />
                  ) : (
                    stepFacetValue === "3" ? (
                      <StepComponent productList={list3} stepTitle={"Step 3 - moisturizer and face oil"} amount={4} 
                        question={question} 
                        quizId={quizId} />
                    ) : ''
                  )}

                  {stepFacetValue === "0" ? (
                    <StepComponent productList={list4} stepTitle={"Step 4 - eye care, sunscreen, neck care, lip care and face oil"} amount={1} 
                      question={question} 
                      quizId={quizId} />
                  ) : (
                    stepFacetValue === "4" ? (
                      <StepComponent productList={list4} stepTitle={"Step 4 - eye care, sunscreen, neck care, lip care and face oil"} amount={4} 
                        question={question} 
                        quizId={quizId} />
                    ) : ''
                  )}
                </div>
                </div>)}

                {cleanedAiAnswer !== "" ? (
                  <div className="actions">
                    <SaveSolutionComponent question={question} list1={list1} list2={list2} list3={list3} list4={list4} suggestion={cleanedAiAnswer} />
                    <button className="btn-new-search" 
                      onClick={() => {handleTryAgain()}}>
                      Quiz Again
                    </button>
                  </div>
                ) : ''}

                
              </div>
            </div>

            <Box className="subscription"
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box className="subscription-wrapper">
                <Box className="subscribe"
                  sx={{
                    width: { xs: "100%", md: "70%" },
                    display: "flex",
                    flexDirection: { xs: "row", md: "row" },
                    justifyContent: "space-between",
                    color: brandingColors["grey-font"],
                    borderRadius: "10px",
                    marginX: "auto",
                  }}
                >
                  <Box className="subscribe-wrapper"
                    sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    }}
                  >
                    <span className="title">
                      Subscribe to our newsletter.
                    </span>
                    <Box className="input-action"
                    sx={{
                      width: { xs: "100%", md: "100%" },
                      flexDirection: { xs: "column", md: "row" },
                    }}
                    >
                    <TextField className="email-input"
                    id="input-with-sx"
                    label="Enter your email"
                    variant="standard"
                    value={email}
                    onChange={handleEmailChange}
                    sx={{
                      display: { xs: "flex", sm: "flex" },
                      color: "white",
                    }}
                    />

                    <Button className="btn btn-subscribe"
                      variant="contained"
                      onClick={() => {
                        if (!_.isEmpty(email)) {
                          subscribe(email, '', '').then(() => handleButtonClick());
                        }
                      }}
                    >
                      Subscribe
                    </Button>
                  </Box>
                </Box>

                
              </Box>

              {showSuccess && <div className="subsribe-success">
                <div><img src="/assets/icon-rocket.svg"/></div>
                <span>Submit successfully!</span>
              </div>}
            </Box>
            </Box>
            <FooterComponent />
          </div>
        </div>
      </div>
    </div>
  );
}
}